// ** React Import
import React from 'react';

// ** Reactstrap Import
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

// ** Style Import
import '@styles/react/community/LatestUpdate.scss';

// ** Utils
import { renderClient } from '../../../utility/Utils';

export default function LatestUpdate() {
  return (
    <Card className="mb-1">
      <CardBody>
        <CardTitle tag="h2">
          <strong>Latest updates</strong>
        </CardTitle>
        <CardText>
          {new Array(6).fill().map(() => {
            return (
              <div className="py-50 px-1 d-flex flex-row align-items-center item-avatar">
                {renderClient({ fullName: 'John Doe', size: 'lg' })}
                <div>
                  {' '}
                  <a href="#">{'John Doe'}</a> posted an update{' '}
                  <a href="#" className="view activity-time-since">
                    <span className="time-since">2 years ago</span>
                  </a>
                </div>
              </div>
            );
          })}
        </CardText>
      </CardBody>
    </Card>
  );
}
